<style>
.bg-primary {
  background-color: #2b4e8a !important;
}

.file {
  visibility: hidden;
  position: absolute;
}
.browse {
  background-color: #1a3665 !important;
  color: white;
}
.custom-file-input ~ .custom-file-label[data-browse]::after {
  background-color: #1a3665 !important;
  color: white !important;
  word-wrap: break-word !important;
  white-space: normal !important;
}
.upload-btn-wrapper {
  width:100%;
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btn-upload {
  width:50%;

  border: 2px solid gray;
  color: gray;
  background-color: white;
  padding: 5px 15px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 30px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
</style>
<template>
<div class="card">
    <header class="card-header bg-primary text-white d-flex align-items-center font-weight-bold"> 
        Tambah Master RPL 
        <button type="button" @click="$router.go(-1)" class="btn btn-md ml-auto mr-2 btn-info">Back</button>
    </header>
    <div class="card-body">
        <div class="card">
            <header class="card-header bg-white text-dark h4"> Sertifikasi RPL </header>
              <div class="card-body">
                
                <div class="form-group">
                    <label for="nama-sertifikasi" class="font-weight-bold">Nama Sertifikasi</label>
                    <input 
                        v-model="formData.namaSertifikasi" 
                        type="text" 
                        class="form-control" 
                        id="nama-sertifikasi" 
                        :class="{
                            'is-invalid': $v.formData.namaSertifikasi.$error,                     
                        }"
                        characterAllow="qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM,. 1234567890-"
                        >
                </div>
                <div class="row">
                    <div class="col">
                        <label for="exampleFormControlSelect1" class="font-weight-bold">Level</label>
                        <multiselect 
                        v-model="level" 
                        @input="(value) => updateLevel(value)"
                        label="namaLevel"
                        :options="levelPeruntukan" 
                        :class="{'invalid-multiselect' : $v.formData.level.$error}"
                        :searchable="true" 
                        :close-on-select="true" 
                        :show-labels="false" 
                        placeholder="Pick a value"
                    ></multiselect>
                    </div>
                    <div class="col">
                        <label for="biaya-pendaftaran" class="font-weight-bold">Biaya Pendaftaran</label>
                        <input type="text" class="form-control" 
                        v-model="formData.biayaPendaftaran" 
                        id="biaya-pendaftaran"
                        readonly
                        >
                    </div>
                   
                </div>
                <br>
                <div class="form-group">
                    <label for="exampleFormControlSelect1" class="font-weight-bold">Status</label>
                    <div class="form-group">
                        <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="modul-active" v-model="formData.status" value="1" class="custom-control-input">
                            <label class="custom-control-label" for="modul-active">Active</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="modul-inactive" v-model="formData.status" value="2" class="custom-control-input">
                            <label class="custom-control-label" for="modul-inactive" >Inactive</label>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="exampleFormControlSelect1" class="font-weight-bold">Action</label>
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" v-model="formData.flagWorkshop" id="subModul">
                            <label class="form-check-label" for="subModul">
                                Enable Workshop
                            </label>
                        </div>
                    </div>
                </div>
                <section v-show="formData.flagWorkshop">
                <div class="row">
                    <div class="col">
                        <label for="biaya-pendaftaran" class="font-weight-bold">Tanggal Mulai</label>
                        <input type="date" v-model="formData.tanggalMulai" class="form-control">
                    </div>
                    <div class="col">
                        <label for="biaya-pendaftaran" class="font-weight-bold">Tanggal Akhir Pendaftaran</label>
                        <input type="date" v-model="formData.tanggalAkhirDaftar" class="form-control">
                    </div>
                    <div class="col">
                        <label for="biaya-pendaftaran" class="font-weight-bold">Jam Mulai</label>
                        <input type="time" v-model="formData.jamMulai" class="form-control">
                    </div>
                    <div class="col">
                        <label for="biaya-pendaftaran" class="font-weight-bold">Jam Selesai</label>
                        <input type="time" v-model="formData.jamAkhir" class="form-control">
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col">
                        <label for="biaya-pendaftaran" class="font-weight-bold">Kapasitas Peserta</label>
                        <input type="number" v-model="formData.kapasitasPeserta" class="form-control">
                    </div>
                    <div class="col">
                        <label for="biaya-pendaftaran" class="font-weight-bold">Jenis Workshop</label>
                        <div class="form-group">
                          <div class="custom-control custom-radio custom-control-inline">
                              <input type="radio" id="jenis-offline" v-model="formData.jenisWorkshop" value="1" class="custom-control-input">
                              <label class="custom-control-label" for="jenis-offline">Offline</label>
                          </div>
                          <div class="custom-control custom-radio custom-control-inline">
                              <input type="radio" id="jenis-online" v-model="formData.jenisWorkshop" value="2" class="custom-control-input">
                              <label class="custom-control-label" for="jenis-online" >Online</label>
                          </div>
                      </div>
                    </div>
                </div>
                <br>
                <div class="form-group" v-if="formData.jenisWorkshop == 1">
                    <label for="deskripsi-modul" class="font-weight-bold">Alamat Workshop</label>
                    <textarea class="form-control" id="deskripsi-modul" @input="location" cols="30" rows="10"></textarea>
                </div>
                <div class="form-group" v-else>
                    <label for="deskripsi-modul" class="font-weight-bold">URL</label>
                    <input type="text" class="form-control" @input="location" >
                </div>
                </section>
                <div class="form-group">
                    <label for="deskripsi-modul" class="font-weight-bold">Deskripsi Sertifikasi</label>
                    <textarea class="form-control" v-model="formData.deskripsiModul" :class="{'is-invalid': $v.formData.deskripsiModul.$error}" id="deskripsi-modul" cols="30" rows="10"></textarea>
                </div>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div class="card">
            <header class="card-header bg-white text-dark"> <h4>Daftar Mata Ujian</h4>
                <span class="text-danger" v-if="$v.formData.rowMataUji.$error">
                  Mata Uji Kosong
                </span>
            </header> 
            <div class="card-body" v-for="(input,k) in formData.rowMataUji" :key="k">
                <div class="form-group row">
                    <label for="inputEmail3" class="col-sm-2 col-form-label">Aksi</label>
                    <button type="button" v-show="k == 0" @click="addDaftarMataUji()" class="btn btn-md btn-info" style="margin-left:15px;">Tambah</button>
                    <button type="button" v-show="k > 0" @click="hapusMataUji(k)" class="btn btn-md btn-danger" style="margin-left:15px;">Hapus</button>
                </div>
                 <div class="form-group row">
                    <label for="Harga Mata Uji" class="col-sm-2 col-form-label">Tipe Mata Uji</label>
                    <div class="col-sm-10">
                      <div class="form-group">
                        <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" :id="`mata-uji-workshop${k}`" value="1" v-model="input.tipeMataUji" class="custom-control-input">
                            <label class="custom-control-label" :for="`mata-uji-workshop${k}`">TC</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" :id="`mata-uji-tc${k}`" value="2" v-model="input.tipeMataUji" class="custom-control-input">
                            <label class="custom-control-label" :for="`mata-uji-tc${k}`">Workshop</label>
                        </div>
                    </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="inputEmail3" class="col-sm-2 col-form-label">Mata Ujian</label>
                    <div class="col-sm-10">
                    <multiselect 
                        v-model="input.dummyMataUji" 
                        :options="optionsMataUji" 
                        label="text"
                        :searchable="true" 
                        @input="(value) => updateMataUji(k, value)"
                        :close-on-select="true" 
                        :show-labels="false" 
                        placeholder="Pick a value"
                    ></multiselect>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="Harga Mata Uji" class="col-sm-2 col-form-label">Harga Mengulang</label>
                    <div class="col-sm-10">
                    <input type="number" class="form-control" v-model="input.harga" id="Harga Mata Uji">
                    </div>
                </div>
            </div> 

        </div>
    </div>
    <div class="card-body">
        <div class="card">
            <header class="card-header bg-white text-dark"> <h4>Dokumen Persyaratan</h4>
                <span class="text-danger" v-if="$v.formData.syaratDokumen.$error">
                    Dokumen persyaratan kosong
                </span>
            </header>
            <div class="card-body" v-for="(input,k) in formData.syaratDokumen" :key="k">
                <div class="row">
                    <div class="form-group col-md-6">
                        <label for="exampleFormControlInput1" class="font-weight-bold">Nama Dokumen</label>
                       <multiselect 
                        v-model="input.dummySyaratDokumen" 
                        :options="optionMasterDokumen" 
                        label="namaDokumen"
                        :close-on-select="true" 
                        @input="(value) => updateSyaratDokumen(k, value)"
                        :show-labels="false" 
                        placeholder="Pick a value">
                        </multiselect>
                    </div>
                    <div class="form-group col-md-5">
                        <label for="exampleFormControlSelect1" class="font-weight-bold">Status Dokumen</label>
                        <select v-model="input.statusRequired" class="form-control" id="exampleFormControlSelect1">
                            <option value="1">Wajib</option>
                            <option value="2">Opsional</option>
                        </select>
                    </div>
                    <div class="col-1 d-flex align-items-center mt-2">
                        <div class="btn btn-sm btn-success ml-2" @click="addSyaratDokumen()" v-show="k == 0">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </div>
                        <div class="btn btn-sm btn-danger ml-2" @click="hapusSyaratDokumen(k)" v-show="k > 0">
                            <i class="fa fa-trash" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div class="card">
            <header class="card-header bg-white text-dark"> 
                <h4>Dokumen Persyaratan Penerbitan Sertifikat</h4> 
                <span class="text-danger" v-if="$v.formData.syaratDokumenPenerbitan.$error">
                    Dokumen persyaratan Penerbitan kosong
                </span>
            </header>
            <div class="card-body" v-for="(input,k) in formData.syaratDokumenPenerbitan" :key="k">
                <div class="row">
                    <div class="form-group col-md-6">
                        <label for="exampleFormControlInput1" class="font-weight-bold">Nama Dokumen</label>
                        <multiselect 
                        :options="optionMasterDokumen" 
                        label="namaDokumen"
                        v-model="input.dummySyaratDokumen" 
                        @input="(value) => updateSyaratDokumenPenerbitan(k, value)"
                        :close-on-select="true" 
                        :show-labels="false" 
                        placeholder="Pick a value"
                    ></multiselect>
                    </div>
                    <div class="form-group col-md-5">
                        <label for="exampleFormControlSelect1" class="font-weight-bold">Status Dokumen</label>
                        <select v-model="input.statusRequired"class="form-control" id="exampleFormControlSelect1">
                            <option value="1">Wajib</option>
                            <option value="2">Opsional</option>
                        </select>
                    </div>
                    <div class="col-1 d-flex align-items-center mt-2">
                        <div class="btn btn-sm btn-success ml-2" @click="addSyaratDokumenPenerbitan()" v-show="k == 0">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </div>
                        <div class="btn btn-sm btn-danger ml-2" @click="hapusSyaratDokumenPenerbitan(k)" v-show="k > 0">
                            <i class="fa fa-trash" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer bg-white border-0 ml-auto mb-3 mr-3">
        <Button
          style="float:right"
          class="btn btn-md btn-success px-4 py-2"
          @click="submitForm()"
          color="success"
        >Simpan</Button>
        <br />
        <br />
      </div>
</div>
</template>
<script>

import { required, maxLength } from 'vuelidate/lib/validators';
import LevelService from "../../../services/datamaster/level.service";
import { MasterDokumen } from "../../../mixins/master/MasterDokumen";
import SertifikasiService from "../../../services/sertifikasi/master-sertifikasi.service.new";
import { AlertUtils } from "../../../mixins/AlertUtils";
import { UploadImage } from "../../../mixins/UploadImage";

export default {
mixins: [MasterDokumen, AlertUtils, UploadImage],
data() {
    return {
        value:'',
        optionsMataUji: [], 
        lihat_foto:'',
        formData: {
            flyer:'',
            namaSertifikasi:'',
            biayaPendaftaran:0,
            level:'',
            status:'1',
            flagRpl:true,
            flagWorkshop:false,
            deskripsiModul:'',
            tanggalMulai:'',
            tanggalAkhirDaftar:'',
            jamMulai:'',
            jamAkhir:'',
            jenisWorkshop:'1',
            kapasitasPeserta:0,
            lokasi:'',
            rowMataUji:[
                {
                    idMataUji:'',
                    harga:0,
                    dummyMataUji:'',
                    tipeMataUji:'1',
                    namaMataUji:''
                }
            ],
            syaratDokumen: [
                {
                    idMasterDokumen: '',
                    statusRequired : '1',
                    dummySyaratDokumen:'',
                    
                }
            ],
            syaratDokumenPenerbitan: [
                {
                    idMasterDokumen: '',
                    statusRequired : '1',
                    dummySyaratDokumen:''
                },
            ]
        },
        levelPeruntukan: {},
        level:''
        
    }   
},
validations() {
  if(this.formData.flagWorkshop) {
    return {
        formData : {
        //   flyer: {
        //     required
        //   },
          namaSertifikasi: { 
            required,
            maxLength: maxLength(100)
          },
        //   biayaPendaftaran: {
        //     required,
        //     minValue:1
        //   },
          level: {
            required
          },
          status: {
            required
          },
          deskripsiModul: {
            required
          },
          rowMataUji: {
            $each: {
                idMataUji: {
                    required
                },
                harga: {
                  required
                },
                tipeMataUji: {
                  required
                }
            }
          },
          syaratDokumen: {
            $each: {
                idMasterDokumen: {
                    required
                }
            }
          },
          syaratDokumenPenerbitan: {
            $each: {
                idMasterDokumen: {
                    required
                }
            }
          },
          tanggalMulai: {
            required
          },
          tanggalAkhirDaftar: {
            required
          },
          jamMulai: {
            required
          },
          jamAkhir: {
            required
          }, 
          kapasitasPeserta: {
            minValue:1
          },
          lokasi: {
            required
          }
      }
    }
  } else {
     return {
        formData : {
          flyer: {
            required
          },
          namaSertifikasi: { 
            required,
            maxLength: maxLength(100)
          },
        //   biayaPendaftaran: {
        //     required,
        //     minValue:1
        //   },
          level: {
            required
          },
          status: {
            required
          },
          deskripsiModul: {
            required
          },
          rowMataUji: {
            $each: {
                idMataUji: {
                    required
                },
                harga: {
                  required
                },
                tipeMataUji: {
                  required
                }
            }
          },
          syaratDokumen: {
            $each: {
                idMasterDokumen: {
                    required
                }
            }
          },
          syaratDokumenPenerbitan: {
            $each: {
                idMasterDokumen: {
                    required
                }
            }
          }
      }
    }
  }
  
  return {
    formData : validate
  }
},
watch: {
  'formData.flagWorkshop'(value) {
    this.formData.tanggalMulai = '',
    this.formData.jamMulai = '',
    this.formData.jamAkhir = '',
    this.formData.kapasitasPeserta = 0
  },
  'formData.jenisWorkshop'(value) {
    this.formData.lokasi = ''
  }
},
mounted() {
    this.getModul()
    this.getLevel()
    this.getAllDokumen()
},
methods: {
    chooseFiles: function() {
      document.getElementById('fileUpload').click();
    },
    location(event) {
      this.formData.lokasi = event.target.value
    },
    getModul() {
        var vm = this
        SertifikasiService.getMataUji()
            .then((res) => {
                vm.optionsMataUji = res.data.items;
                
            });
    },
    addDaftarMataUji() {
        this.formData.rowMataUji.push(
            {
                idMataUji:"",
                harga:0,
                dummyMataUji:"",
                tipeMataUji:'1',
                namaMataUji:""
            }
        )    
    },
    hapusMataUji(k) {
        this.formData.rowMataUji.splice(k,1)
    },
    addSyaratDokumen() {
        this.formData.syaratDokumen.push(
            {
                idDokumenPendukung : "",
                idMasterDokumen: "",
                invalid_dokumen : false,
                statusRequired : '1',
                modelMultiSelect: [],
                dummySyaratDokumen: ""
            }
        )
    },
    addSyaratDokumenPenerbitan() {
        this.formData.syaratDokumenPenerbitan.push(
            {
                idDokumenPendukung : "",
                idMasterDokumen: "",
                invalid_dokumen : false,
                statusRequired : '1',
                modelMultiSelect: [],
                dummySyaratDokumen:""
            }
        )
    },
    hapusSyaratDokumenPenerbitan(k) {
        this.formData.syaratDokumenPenerbitan.splice(k,1);
    },
    hapusSyaratDokumen(k) {
        this.formData.syaratDokumen.splice(k,1);
    },
    getLevel() {
      var vm = this;
      LevelService.getAllLevel()
        .then((response) => {
          vm.levelPeruntukan = response.data.data.content;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },
    submitForm() {
        this.$v.$touch();
        const falseFault = []
        // if(this.$v.formData.namaSertifikasi.$error) {
        //     falseFault.push(false)    
        // }

        // if(this.$v.formData.biayaPendaftaran.$error) {
               
        //     falseFault.push(false)
        // }

        // if(this.$v.formData.level.$error) {
              
        //     falseFault.push(false) 
        // }

        // if(this.$v.formData.namaSertifikasi.$error) {
               
        //     falseFault.push(false)
        // }

        // if(this.$v.formData.deskripsiModul.$error) {
               
        //     falseFault.push(false)
        // }

        // if(this.$v.formData.rowMataUji.$error) {
               
        //     falseFault.push(false)
        // }

        // if(this.$v.formData.syaratDokumen.$error) {
            
        //     falseFault.push(false)   
        // }

        // if(this.formData.flagWorkshop) {
        //    if(this.$v.formData.lokasi.$error) {
                  
        //         falseFault.push(false) 
        //     }
            
        //     if(this.$v.formData.kapasitasPeserta.$error) {
                  
        //         falseFault.push(false) 
        //     }
            
        //     if(this.$v.formData.tanggalMulai.$error) {
                  
        //         falseFault.push(false) 
        //     }

        //     if(this.$v.formData.tanggalAkhirDaftar.$error) {
                  
        //         falseFault.push(false) 
        //     }
            
        //     if(this.$v.formData.jamMulai.$error) {
                  
        //         falseFault.push(false) 
        //     }

        //     if(this.$v.formData.jamAkhir.$error) {
                  
        //         falseFault.push(false) 
        //     }
        // }
       

        // if(this.$v.formData.flyer.$error) {
              
        //     falseFault.push(false) 
        // }

        // if(falseFault.indexOf(false) == 0) {
        //     this.$swal.fire(
        //       "Error",
        //       "Item Data Kosong",
        //       "error"
        //     );
        //     return false;
        // } else {
            this.processSubmit()
        // }
    },
    processSubmit() {
        var vm = this;
        vm.formData.flyer = vm.lihat_foto;
        SertifikasiService.postSertifikasiRpl(this.formData)
        .then((response) => {
            console.log(response);
            // vm.myModal = false;
            // vm.alertSuccess();
            vm.$router.push({ path: "/sertifikasi-new/master-sertifikasi" });
        })
        .catch((error) => {
            console.log(error)
            this.$swal.fire(
              "Error",
              error.message,
              "error"
            );
        });
    },
    updateLevel(value) {
        this.formData.level = value.idLevelAnggota
        this.formData.biayaPendaftaran = 'Rp. '+this.formatPrice(value.hargaLevel);
    },
    updateMataUji(k, value) {
        this.formData.rowMataUji[k].idMataUji = value.id
        this.formData.rowMataUji[k].namaMataUji = value.text
    },
    updateSyaratDokumen(k, value) {
        this.formData.syaratDokumen[k].idMasterDokumen = value.idMasterDokumen
    },
    updateSyaratDokumenPenerbitan(k, value) {
        this.formData.syaratDokumenPenerbitan[k].idMasterDokumen = value.idMasterDokumen
    },
    formatPrice(value) {
        if(isNaN(value)) {
            return '0.00';
        } else {
            let val = (value / 1).toFixed(2).replace(".", ",");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
    },
}
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
